var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0771008 12.8833L0.760566 7.30807C1.17693 5.31868 2.35531 4.5 3.47871 4.5H12.5051C13.6443 4.5 14.8619 5.26137 15.2154 7.30807L15.9068 12.8833C16.4724 16.9767 14.3906 18 11.6724 18H4.30358C1.59329 18 -0.425676 16.5182 0.0771008 12.8833Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5806 9.13372C11.0145 9.13372 11.3662 8.76719 11.3662 8.31505C11.3662 7.8629 11.0145 7.49637 10.5806 7.49637C10.1468 7.49637 9.79503 7.8629 9.79503 8.31505C9.79503 8.76719 10.1468 9.13372 10.5806 9.13372Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43462 9.13372C5.86849 9.13372 6.22021 8.76719 6.22021 8.31505C6.22021 7.8629 5.86849 7.49637 5.43462 7.49637C5.00075 7.49637 4.64903 7.8629 4.64903 8.31505C4.64903 8.76719 5.00075 9.13372 5.43462 9.13372Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57867 4.29689C3.57588 4.3667 3.58913 4.43621 3.61738 4.5H4.89482C4.91956 4.43515 4.93266 4.36637 4.93353 4.29689C4.93353 2.57114 6.32002 1.17215 8.03034 1.17215C9.74066 1.17215 11.1271 2.57114 11.1271 4.29689C11.1154 4.36408 11.1154 4.43281 11.1271 4.5H12.4355C12.4473 4.43281 12.4473 4.36408 12.4355 4.29689C12.3361 1.89532 10.3777 0 7.9955 0C5.61332 0 3.65486 1.89532 3.55545 4.29689H3.57867Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagNew);
export default __webpack_public_path__ + "static/media/Bag_new.0a01819aaf415736033b5f49b376a589.svg";
export { ForwardRef as ReactComponent };